/**
 * P2P Configuration Settings
 * Centralized configuration for LibP2P and Helia services.
 */

// Basic constants
const KB = 1024;
const SECOND = 1000;
const MINUTE = 60 * SECOND;

// Critical sizing constant
// This was previously in debugConfig.ts
export const CHUNK_SIZE = 256 * KB;

export const P2P_CONFIG = {
  network: {
    // Default bootstrap address - the HAP server
    defaultBootstrap: [
       '/dns4/dev-p2p.hap-alpha.six3ro.net/tcp/443/wss/p2p/12D3KooWADcdhDiFp8PYP12wTgfN3VUu1XABvt2QU1DAJ9FPew4K'
    ],
    // Default swarm key (must match HAP)
    defaultSwarmKey: 'c2b1e8f7a9d4c3b6e5f8a1d2c3b4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2',
    maxConnections: 250,
    autoDial: true,
  },

  yamux: {
    // CRITICAL FIX: Reduce Max Streams
    // This prevents Bitswap from opening too many parallel streams and choking the connection.
    maxInboundStreams: 256,
    maxOutboundStreams: 256,
    enableKeepAlive: true,
    keepAliveInterval: 20 * SECOND, // 20s
    // Window sizes
    clientStreamWindowSize: CHUNK_SIZE,
    maxStreamWindowSize: CHUNK_SIZE * 2,
    initialStreamWindowSize: CHUNK_SIZE,
  },

  ping: {
    timeout: 90 * SECOND,
  },

  bitswap: {
    protocolPrefix: '/ipfs/bitswap',
    // Reduce parallelism to prevent congestion collapse
    maxInboundStreams: 8,      // Down from 32
    maxOutboundStreams: 16,    // Down from 128 - KEY SETTING
    messageSendConcurrency: 4, // Down from 50 - controls WANT parallelism
    sendBlocksConcurrency: 4,  // Down from 50
    sendBlocksDebounce: 50,    // Up from 10ms - adds breathing room

    // CRITICAL: Increase all timeouts to survive slow networks
    incomingStreamTimeout: 3 * MINUTE,  // 2 minutes - prevent premature stream closure
    outgoingStreamTimeout: 4 * MINUTE,  // 2 minutes - match incoming
    sendBlocksTimeout: 5 * MINUTE,       // 1 minute - time to send a block
    receiveBlocksTimeout: 6 * MINUTE,   // 2 minutes - time to receive blocks
    streamIdleTimeout: 3 * MINUTE       // 3 minutes - keep streams alive during slow transfers
  },

  connectionManager: {
    maxConnections: 250,
    minConnections: 1,
    maxPeerAddrsToDial: 100,
    inboundConnectionThreshold: 10,
    autoDialInterval: 10 * SECOND,
    dialTimeout: 30 * SECOND,
  },

  logging: {
    peerIdLogLength: 20,
    statsLogInterval: 5 * SECOND,
    namespace: {
        libp2p: 'six3ro:p2p:libp2p',
        helia: 'six3ro:p2p:helia'
    }
  }
};
